import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const formatDate = (date: string | Dayjs | Date) => {
  return dayjs(date).format('YYYY-MM-DD');
};
